import styled from 'styled-components/macro';

export const LabelText = styled.span`
  bottom: 2px;
  font-size: 14px;
  left: 5px;
  margin-left: 12px;
  position: relative;
`;
